import routerOptions0 from "/application/node_modules/.pnpm/nuxt@3.15.1_@parcel+watcher@2.5.0_@types+node@22.10.1_db0@0.2.1_eslint@8.57.1_ioredis@5_1596d5bc1c592ff1dcc428e60f2821d4/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/application/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}